import DataMap from 'assets/components/dataMap/DataMap';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { isEmpty } from 'lodash';
import { CountryCode, CountryCodeFallback } from 'models/enums/CountryCode';
import Currency from 'models/enums/Currency';
import { ClaimEditJobPayeeItemProvider } from '../../ClaimEdit.Job.Hooks';
import ClaimEditJobItemDeductible from '../ClaimEdit.Job.Item.Deductible';

type Props = {
  items: Array<{ item: Utils.FormData<Model.IClaimJobItem>; index: number }>;
  isWarrantyProduct: boolean;
  updateJobItem(data: Utils.FormData<Model.IClaimJobItem>, index?: number): void;
  currency: string;
  insurerHeaders?: string[];
};

const ClaimEditJobDeductibleTable = ({ items, isWarrantyProduct, currency, updateJobItem, insurerHeaders }: Props) => {
  const { lang } = getLocales();
  const countryCode =
    currency === Currency.USD ? CountryCode.USA : currency === Currency.CAD ? CountryCode.CAN : CountryCodeFallback.CA;

  return (
    <>
      <h4>{lang.deductible}</h4>
      <table className={ThemeTableSimple} style={{ fontSize: Theme.FontSize.S }}>
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>{lang.payee}</th>
            <th style={{ textAlign: 'center' }}>{lang.status}</th>
            <th style={{ textAlign: 'center' }}>{lang.requestedAmt}</th>
            <th style={{ textAlign: 'center' }}>{lang.adjustedAmt}</th>
            {!isEmpty(insurerHeaders) &&
              insurerHeaders.map((header) => (
                <th key={header} style={{ textAlign: 'center' }}>
                  {header}
                </th>
              ))}
            <th style={{ textAlign: 'center' }}>{lang.total}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <ClaimEditJobPayeeItemProvider countryCode={countryCode}>
            <DataMap
              data={items}
              render={({ data: { item, index } }) => (
                <ClaimEditJobItemDeductible
                  key={index}
                  data={{ ...item, isWarrantyProduct }}
                  insurerHeaders={insurerHeaders}
                  onUpdate={(data) => updateJobItem({ ...item, ...data }, index)}
                  countryCode={countryCode}
                />
              )}
            />
          </ClaimEditJobPayeeItemProvider>
        </tbody>
      </table>
    </>
  );
};

export default ClaimEditJobDeductibleTable;
